module.exports = __webpack_public_path__ + "img/no-login-streak.fb4cc354.svg";